import { TranslationRowType } from "./translationConstants";

export function parseTranslationBlob(jsonString) {
  if (!jsonString) return { flow: {}, nodes: {} };
  if (typeof jsonString !== "string") return jsonString;
  try {
    const parsed = JSON.parse(jsonString);
    return { flow: parsed.flow || {}, nodes: parsed.nodes || {} };
  } catch (e) {
    return { flow: {}, nodes: {} };
  }
}

export function mergeNodeIntoLanguageBlob(fullBlob, nodeId, nodeBlob) {
  const base = fullBlob || { flow: {}, nodes: {} };
  const nodes = { ...base.nodes };
  if (nodeBlob.nodes && nodeBlob.nodes[nodeId]) {
    nodes[nodeId] = nodeBlob.nodes[nodeId];
  } else {
    delete nodes[nodeId];
  }
  return { flow: { ...base.flow }, nodes };
}

export function findDuplicateOptionRowIds(tableData, lang) {
  const rowIdsByNodeAndLabel = {};
  tableData.forEach((row) => {
    if (row.type !== TranslationRowType.OPTION) return;

    const langData = row.translations && row.translations[lang];
    const translated = langData && langData.group && langData.group[0] ? langData.group[0].value : "";
    const displayed = (translated || "").trim() || ((row.baseTranslations && row.baseTranslations.option) || "").trim();
    if (!displayed) return;

    const byLabel = rowIdsByNodeAndLabel[row.nodeId] || (rowIdsByNodeAndLabel[row.nodeId] = {});
    (byLabel[displayed] || (byLabel[displayed] = [])).push(row.id);
  });

  const duplicateIds = new Set();
  Object.values(rowIdsByNodeAndLabel).forEach((byLabel) => {
    Object.values(byLabel).forEach((ids) => {
      if (ids.length > 1) ids.forEach((id) => duplicateIds.add(id));
    });
  });
  return duplicateIds;
}

// Rebuild the per-language blob from current table state. Only non-empty values
// are written, so removed nodes/options drop out.
export function buildLanguageBlob(tableData, lang) {
  const blob = { flow: {}, nodes: {} };

  const nodeBucket = (nodeId) => {
    if (!blob.nodes[nodeId]) blob.nodes[nodeId] = {};
    return blob.nodes[nodeId];
  };

  tableData.forEach((row) => {
    const langData = row.translations && row.translations[lang];
    if (!langData || !langData.group) return;

    const values = {};
    langData.group.forEach(({ key, value }) => {
      if (value && value.trim().length > 0) values[key] = value;
    });
    if (Object.keys(values).length === 0) return;

    if (row.type === TranslationRowType.FLOW) {
      Object.assign(blob.flow, values);
    } else if (row.type === TranslationRowType.NODE) {
      Object.assign(nodeBucket(row.nodeId), values);
    } else if (row.type === TranslationRowType.OPTION) {
      const node = nodeBucket(row.nodeId);
      if (!node.options) node.options = {};
      node.options[row.optionIndex] = values.option;
    }
  });

  return blob;
}
